import React from 'react'
import Navbar from '../components/Navbar'

export default function Analytics() {
  return (
    <div className='page-position-default'>
        <Navbar/>
    </div>
  )
}
